exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-el-header[data-v-fd0c4ee2]{position:fixed;width:100%;top:0;left:0;z-index:500;height:60px!important;background-color:#ec1c1c;color:#fff;-webkit-box-shadow:0 2px 8px 0 rgba(38,38,38,.35);box-shadow:0 2px 8px 0 rgba(38,38,38,.35)}.header[data-v-fd0c4ee2]{margin:0 auto}.header .jzq-logo[data-v-fd0c4ee2]{height:60px;line-height:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fd0c4ee2","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./layouts/headernomsg.vue
// module id = G1Zt
// module chunks = 200